
import {ExportRegistry} from "./ExportRegistry.js";
import {buildExportFilename} from "./exportFilename.js";

import {T} from "../i18n/index.js";
function toGeoJSON(features, projection, epsg = null){
	const collection = {
		type: "FeatureCollection",
		features: features.map(f => ({
			type: "Feature",
			id: f.id,
			geometry: f.geometry,
			properties: {
				id: f.id,
				name: f.properties.name,
				category: f.properties.category,
				tool: f.properties.tool,
				featureType: f.properties.featureType,
				description: f.properties.description,
				created: f.metadata.created,
				modified: f.metadata.modified,
				...f.properties.attributes,
			},
		})),
	};

	// Kendt horisontal EPSG (fra host-appen) skrives som standard-URN; ellers
	// som før den projektion, punktskyen selv oplyser (hvis nogen).
	const crsName = epsg ? `urn:ogc:def:crs:EPSG::${epsg}` : projection;
	if(crsName){
		collection.crs = {
			type: "name",
			properties: {name: crsName},
		};
	}

	return collection;
}

export const GeoJSONFeatureExporter = {
	id: "geojson",
	name: T("GeoJSON"),
	extension: "geojson",
	disabled: false,
	description: T("Alle attributter og koordinater med højde (Z). Egnet til GIS og web."),
	crsHandling: "embedded",
	export(features, context = {}){
		const geojson = toGeoJSON(features, context.projection, context.epsg);

		return {
			filename: buildExportFilename(context.pointcloudName, "geojson", context.exportDate),
			text: JSON.stringify(geojson, null, 2),
			mimeType: "application/geo+json",
		};
	},
};

ExportRegistry.register(GeoJSONFeatureExporter);
